import { LiquiditySource } from './liquidity-source';
import { LiquiditySourceConfigDto } from '../dto';

export class LiquiditySourceConfig {
  // TODO: add tag include/exclude

  public liquiditySources: LiquiditySource[];

  constructor(liquiditySources: LiquiditySource[]) {
    this.liquiditySources = liquiditySources;
  }

  public getEnabledCount(): number {
    return this.liquiditySources.filter(source => source.enabled).length;
  }

  public getTotalCount(): number {
    return this.liquiditySources.length;
  }

  public getDto(): LiquiditySourceConfigDto {
    const dto = new LiquiditySourceConfigDto();
    dto.sources = {};
    dto.sources.include = {};

    this.liquiditySources.forEach(source => {
      if (source.enabled) {
        dto.sources!.include![source.identifier] = {};
        dto.sources!.include![source.identifier].subSources = {};
        source.subLiquiditySources?.forEach(subSource => {
          if (subSource.enabled) {
            dto.sources!.include![source.identifier].subSources![
              subSource.identifier
            ] = {};
          }
        });
      }
    });

    return dto;
  }

  public equals(other: LiquiditySourceConfig): boolean {
    if (this.getTotalCount() !== other.getTotalCount()) {
      return false;
    }
    if (this.getEnabledCount() !== other.getEnabledCount()) {
      return false;
    }

    for (const thisSource of this.liquiditySources) {
      const otherSource = other.liquiditySources.find(
        source => source.identifier === thisSource.identifier,
      );
      if (!otherSource) {
        return false;
      }

      if (!thisSource.equals(otherSource)) {
        return false;
      }
    }

    return true;
  }
}
